export const getHost = req => {
  return req?.headers?.host || window.location.host;
};
